export enum TazapayMethodsEnum {
  CARD = "cards",
  INTERNATIONAL = "wire_transfer",
  LOCAL = "local_bank_transfer",
  OTHER = "apm",
}
